import React, {} from 'react';
import {connect} from "react-redux";
import SqftNavAside from "../../components/navigation/SqftNavAside";
import SqftNavAside2 from "../../components/navigation/SqftNavAside2";
import SqftNavAsideCabinet from "../../components/navigation/cabinet/SqftNavAsideCabinet";
import SqftNavigationCabinet from "../../components/navigation/cabinet/SqftNavigationCabinet";
import SqftNavigation from "../../components/navigation/SqftNavigation";
import SqftNavShapes from "../../components/navigation/SqftNavShapes";
import SqftNavLayouts from "../../components/navigation/SqftNavLayouts";
import SqftNavSummary from "../../components/navigation/SqftNavSummary";
import SqftNavEdges from "../../components/navigation/SqftNavEdges";
import SqftNavAppliances from "../../components/navigation/SqftNavAppliances";
import SqftNavBumpouts from "../../components/navigation/SqftNavBumpouts";
import SqftNavBacksplashes from "../../components/navigation/SqftNavBacksplashes";
import SqftNavCorners from "../../components/navigation/SqftNavCorners";
import WallsUpModeButton from "../../components/navigation/secondNavigationRow/WallsUpModeButton";
import WallsLockModeButton from "../../components/navigation/secondNavigationRow/WallsLockModeButton";
import ShowMeasurementsInTheSlabModeButton from "../../components/navigation/secondNavigationRow/ShowMeasurementsInTheSlabModeButton";
import SqftNavigationUpper from "../../components/navigation/cabinet/SqftNavigationUpper";
import SqftNavigationHandles from "../../components/navigation/cabinet/SqftNavigationHandles";
import SqftNavigationBottom from "../../components/navigation/cabinet/SqftNavigationBottom";
import SqftNavigationCrownMolding from "../../components/navigation/cabinet/SqftNavigationCrownMolding";
import SqftNavFeatures from "../../components/navigation/SqftNavFeatures";
import {SIDEBAR_NAVIGATION_CABINET_BUTTONS} from "../../constants";
import SqftNavAsideSlabMode from "../../components/navigation/SqftNavAsideSlabMode";
import SqftNavSeam from "../../components/navigation/slab/SqftNavSeam";
import SqftNavMitered from "../../components/navigation/SqftNavMitered";
import SqftNavUnderlayment from "../../components/navigation/SqftNavUnderlayment";
import SqftNavWaterfall from "../../components/navigation/SqftNavWaterfall";
import {getIsSFTAreaGroup, isSFTCabinetsGroup} from "../../helpers/sqftNavigationHelper";

const NavigationSidebar = (props) => {
  // other popups, modals and so on
  const {activeButton, isShowSlabTool} = props;
  const isCabinet = isSFTCabinetsGroup();
  const isSFTAreaGroup = getIsSFTAreaGroup();

  const navAside = () => {
    return isCabinet ? <SqftNavAsideCabinet />
      : isShowSlabTool
        ? <SqftNavAsideSlabMode/>
        : <SqftNavAside sqftGroup={isSFTAreaGroup}/>
  }

  return (
    <div>
      <div className="sqft-nav">
        {
          navAside()
        }
        <SqftNavAside2/>
        { isCabinet ? <SqftNavigationCabinet/> : <SqftNavigation/> }
        <SqftNavShapes/>
        { !isSFTAreaGroup ? <SqftNavLayouts/> : null}
        <SqftNavSummary/>
        <SqftNavEdges/>
        <SqftNavAppliances/>
        <SqftNavBacksplashes/>
        <SqftNavCorners/>
        <SqftNavBumpouts/>
        <SqftNavSeam/>
        <SqftNavMitered/>
        <SqftNavUnderlayment/>
        <SqftNavWaterfall/>
        { isCabinet ? <SqftNavigationUpper/> : null }
        { isCabinet ? <SqftNavigationBottom/> : null }
        { isCabinet ? <SqftNavigationHandles/> : null }
        { isCabinet ? <SqftNavigationCrownMolding/> : null }
        { isCabinet ? <SqftNavFeatures/> : null }
      </div>
      <div className="sqft-nav__second">
        {/*<FreeDrawModeButton />*/}
        { isCabinet && activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall ? <WallsUpModeButton /> : null }
        { isCabinet && activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall
          || !isCabinet && !isShowSlabTool
            ? <WallsLockModeButton />
            : null
        }
        { isShowSlabTool ? <ShowMeasurementsInTheSlabModeButton /> : null }
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton,
  isShowSlabTool: store.sqftSlabState.isShowSlabTool,
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationSidebar);
